import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router'
import { IconLinkOff } from '@tabler/icons-react'
import Typography from 'src/components/atoms/Typography'
import { SecondaryButton } from 'src/components/atoms/buttons/SecondaryButton'
import AuthWrapper from 'src/enviroment/layouts/auth-wrapper'
import { ROUTES } from 'src/types/routes'

const OauthConsentExpired: React.FC = () => {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>RAMO - Connection link expired</title>
      </Helmet>
      <AuthWrapper>
        <div className="space-y-8">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-red-ramo/20">
            <IconLinkOff className="h-7 w-7 text-red-ramo" />
          </span>
          <div className="space-y-4">
            <Typography variant="4xl-bold" className="text-light-green-50">
              This link no longer works
            </Typography>
            <Typography variant="base" className="text-light-green-100">
              The connection request has expired, was already answered, or was opened in a different browser than the
              one that started it.
            </Typography>
            <Typography variant="base" className="text-light-green-100">
              Go back to your app and start connecting to RAMO again.
            </Typography>
          </div>
          <SecondaryButton fullWidth onClick={() => navigate(ROUTES.PROJECTS)}>
            Go to RAMO
          </SecondaryButton>
        </div>
      </AuthWrapper>
    </>
  )
}

export default OauthConsentExpired
